import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ClassTransformerHelper } from '../../../helpers/class.transformer.helper';
import { WorkflowType } from '../../../models/enums/workflowtype.enum';
import { WorkflowStatus } from '../../../models/workflow/workflow.model';
import { StandardRequestBase } from '../../../services/request-base';
import { WorkflowRegistry } from '../../../services/workflow.service';
import { ARestCallSettings, ARestCallSettingsData, ARestCallSettingsDataHelper, RestCallAdvancedSettings } from './restCall.settings';

@Component({
    selector: 'agent-rest-settings',
    templateUrl: './agent.rest.settings.html',
    styleUrls: ['./restCall.settings.css']
})
export class AgentRestSettings extends ARestCallSettings {
    Agents = [];

    get ActualAgentID() {
        if (this.Data) {
            return this.Data['AgentID'];
        }
        return '';
    }
    set ActualAgentID(val) {
        if (this.Data) {
            this.Data['AgentID'] = val;
        }
    }

    static ModuleID = 'agentRestWFModule';

    public static GetRegistry(): WorkflowRegistry {
        const reg = new WorkflowRegistry();
        reg.ID = AgentRestSettings.ModuleID;
        reg.Caption = '@@Agent Restaufruf';
        reg.GroupID = 'wfActions';
        reg.Index = 32;
        reg.SettingsControl = AgentRestSettings;
        reg.SettingsTypeHelper = new AgentRestSettingsDataHelper();
        reg.WorkflowType = WorkflowType.Service;
        return reg;
    }

    constructor(protected translate: TranslateService, private agentService: StandardRequestBase) {
        super(translate);
    }

    initialize(data: any) {
        super.initialize(data);
        if (data) {
            this.Data = ClassTransformerHelper.CopyObject(data, AgentRestSettingsData);
        } else {
            this.Data = new AgentRestSettingsData();
        }
        this.agentService.executeGet('config/api/agent', 'GetAllAgents').subscribe(agents => {
            const agentList = [];
            if (agents) {
                agentList.push(...agents);
            }
            this.Agents = agentList;
        });
    }

    checkForErrors(errorList: string[]) {
        if (!this.Data['AgentID']) {
            errorList.push(this.translate.instant('@@Fehlender Agent'));
        }
    }

    getPreview(): string {
        try {
            const state = new WorkflowStatus('', '');
            state.ActualSettings = this.Data;
            return RestCallAdvancedSettings.getURL(state);
        } catch {
            return 'ERROR';
        }
    }
}

export class AgentRestSettingsData extends ARestCallSettingsData {
    AgentID: string;

    getTypeName(): string {
        return 'evidanza.MiddleWare.Shared.Workflow.Rest.AgentRestSettingsData';
    }
}

export class AgentRestSettingsDataHelper extends ARestCallSettingsDataHelper {
    getEmptySettingsInstance() {
        return new AgentRestSettingsData();
    }
}
